import React from 'react';
import { ChevronDown } from 'lucide-react';
import { Instagram } from 'lucide-react';
import { cn } from '@/lib/utils';
import TiktokIcon from '@/components/ui/TiktokIcon';

const AccountFilter = ({ platforms = [], selectedAccount, onSelectAccount, activeTab = 'all', onTabChange }) => {
  const accounts = React.useMemo(() => {
    if (!platforms || !Array.isArray(platforms)) return [];
    
    return platforms.reduce((acc, platform) => {
      if (platform?.accounts && Array.isArray(platform.accounts)) {
        return [...acc, ...platform.accounts];
      }
      return acc;
    }, []);
  }, [platforms]);

  const tabs = [
    { id: 'all', label: 'All', count: accounts.length },
    { 
      id: 'instagram', 
      label: 'Instagram',
      icon: <Instagram className="w-4 h-4" />,
      count: accounts.filter(a => a?.platform === 'instagram').length 
    },
    { 
      id: 'tiktok', 
      label: 'TikTok',
      icon: <TiktokIcon className="w-4 h-4" />,
      count: accounts.filter(a => a?.platform === 'tiktok').length 
    }
  ];

  return (
    <div className="w-full">
      <div className="flex flex-wrap items-center gap-1.5">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              "h-7 px-2 rounded-full text-xs font-medium transition-colors flex items-center gap-1.5 shrink-0",
              activeTab === tab.id
                ? "bg-purple-500 text-white"
                : "bg-gray-900/50 hover:bg-gray-800 text-gray-400 border border-gray-700"
            )}
          >
            {tab.icon}
            <span>{tab.label}</span>
            {tab.count > 0 && (
              <span className={cn(
                "text-xs px-1.5 py-0.5 rounded-full",
                activeTab === tab.id
                  ? "bg-white/20"
                  : "bg-gray-700"
              )}>
                {tab.count}
              </span>
            )}
          </button>
        ))}

        {/* Account Dropdown */}
        {accounts.length > 1 && (
          <div className="relative shrink-0">
            <select
              value={selectedAccount || ''}
              onChange={(e) => onSelectAccount(e.target.value || null)}
              className="h-7 px-2 appearance-none bg-gray-900/50 border border-gray-700 rounded-lg text-xs text-gray-300
                focus:ring-2 focus:ring-purple-500/30 focus:border-purple-400
                transition-all duration-200 pr-7"
            >
              <option value="">All</option>
              {accounts.map((account) => (
                <option key={account?.uid || Math.random()} value={account?.uid || ''} className="flex items-center gap-1.5">
                  @{account?.username || 'Unknown'}
                </option>
              ))}
            </select>
            <div className="absolute right-1.5 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
              <ChevronDown className="h-3.5 w-3.5" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountFilter; 